import ClientService, {
  getHemisphereSessionToken,
  notifyHemisphereSessionExpired,
} from "./client-service";
class EntitiesProxyService extends ClientService {
  constructor() {
    super(process.env.VUE_APP_ENTITIES_PROXY_URL, {
      headerProvider() {
        const headers: any = {
          "Content-Type": "application/json",
          Region: "eu-west",
        };
        const token = getHemisphereSessionToken();
        if (token) {
          headers["Authorization"] = "Bearer " + token;
        }
        return headers;
      },
      deconnectionHandler() {
        notifyHemisphereSessionExpired();
      },
    });
  }
  getItsInfoAccount(buildingId: string) {
    return this.client.get(`/${buildingId}/itsinfo-account`);
  }
  getTags(buildingId: string) {
    return this.client.get(`/${buildingId}/tags`);
  }
  getZones(buildingId: string) {
    return this.client.get(`/${buildingId}/zones`);
  }
}
const entitiesProxyService = new EntitiesProxyService();

export default entitiesProxyService;
